/**
 * ⭐ **예약이 「지난 시간」인지 — 판정을 한 곳에** (2026-10-01).
 *
 * ## 왜 모으나
 *
 * 이 규칙은 **서버가 정한다** — 그 글자를 그대로 옮겨 둔다:
 * ```
 *   apps/chat-server/src/modules/reservation/reservation-helpers.ts:184
 *     if (end.getTime() <= now.getTime()) return 'IN_THE_PAST';
 *   그 코드가 사용자에게 내는 말(reservation.service.ts:41):
 *     「이미 지난 시간은 예약할 수 없습니다.」
 * ```
 * ⚠ **`start` 가 아니라 `end`** 다. 그래서 「지금 진행 중인 시간대」는 «예약할 수 있다».
 *   거꾸로 적으면(start < now) 진행 중인 회의실을 못 잡는다 — 흔한 조작을 막는 셈이다.
 *
 * ## ⛔ 왜 함수여야 하나
 *
 * 종전에는 예약 화면 한 곳에만 **인라인 한 줄**로 있었다
 * (`ReservationBookPage.tsx` `commitSelection` 안). 그런데 **일정 창에도 같은 판정이 필요해졌다**
 * (2026-10-01 운영: 회의실을 켜고 지난 시간으로 저장하면 «일정만» 저장되고 방만 거절됐다).
 * ⇒ ★ 거기서 또 한 줄 적으면 「같은 뜻을 다른 글자로」가 되고, 서버 규칙이 바뀌는 날 한 곳만 고친다.
 *
 * ## ⚠ 이 함수가 «안» 하는 것
 *
 * 슬롯 격자(NOT_ALIGNED) · 운영시간(closeMinute) · 날짜 넘김(SPANS_MULTIPLE_DAYS) · 잔여 수량은
 * **여기서 안 본다.** 그 넷은 자원마다 규칙이 다르고, 잔여 수량은 서버가 «행을 잠근 채» 판정한다.
 * ⇒ ★ 화면에서 미리 막을 수 있는 것은 「지난 시간」 하나다 — 그것만 막고 나머지는 서버에 맡긴다.
 */

/** 예약하려는 구간이 이미 지났나. 서버 `validateRequestedRange` 의 `IN_THE_PAST` 와 같은 잣대다. */
export function isReservationInThePast(end: Date, now: Date): boolean {
  return end.getTime() <= now.getTime();
}
